import apps from './apps/apps.module.js';
import auth from './auth/auth.module.js';
import retentionTrends from './retention-trends/retention-trends.module.js';
import adoptionTrends from './adoption-trends/adoption-trends.module.js';
import trendsSettings from './trends/trends-settings.module.js';
import coreEvents from './core-events/core-events.module.js';
import devicesConnection from './devices-connection/devices-connection.module.js';
import domains from './domains/domains.module.js';
import emails from './emails/emails.module.js';
import essentialContacts from './essential-contacts/essential-contacts.module.js';
import experiments from './experiments/experiments.module.js';
import features from './features/features.module.js';
import featureFlags from './feature-flags/feature-flags.module.js';
import globalFilters from './global-filters/global-filters.module.js';
import insights from './insights/insights.module.js';
import itemGroups from './item-groups/item-groups.module.js';
import labels from './labels/labels.module.js';
import metaGroups from './meta-groups/meta-groups.module.js';
import metadata from './metadata/metadata.module.js';
import predict from './predict/predict.module';
import pages from './pages/pages.module.js';
import suggestedPages from './pages/suggested-pages/suggested-pages.module.js';
import productLines from './product-lines/product-lines.module.js';
import savedFilters from './saved-filters/saved-filters.module.js';
import subscription from './subscription/subscription.module.js';
import superSubscription from './subscription/super/super.module.js';
import trackTypes from './track-types/track-types.module.js';
import users from './users/users.module.js';
import filters from './voc-items/filters/filters.module.js';
import vocJira from './voc-items/jira/jira.module.js';
import vocRoadmaps from './voc-items/roadmaps/roadmaps.module.js';
import workflows from './workflows/workflows.module.js';

export default {
    insights,
    savedFilters,
    productLines,
    domains,
    vocItems: {
        namespaced: true,
        modules: {
            filters,
            roadmaps: vocRoadmaps,
            jira: vocJira,
        },
    },
    auth,
    itemGroups,
    experiments,
    trackTypes,
    emails,
    features,
    featureFlags,
    labels,
    workflows,
    retentionTrends,
    adoptionTrends,
    trendsSettings,
    predict,
    devicesConnection,
    coreEvents,
    subscription: {
        ...subscription,
        modules: {
            super: superSubscription,
        },
    },
    globalFilters,
    users,
    metaGroups,
    essentialContacts,
    pages: {
        ...pages,
        modules: {
            suggestedPages,
        },
    },
    apps,
    metadata,
};
